export default "__VITE_ASSET__BXwkKAmj__"